import script from "./tab-1.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-1.vue?vue&type=script&setup=true&lang=js"

import "./tab-1.vue?vue&type=style&index=0&id=9654f160&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9654f160"]])

export default __exports__